import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconInitiatives: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="initiatives, nav, rooting"><path d="M3.26389 15.0479C2.93096 14.0935 2.75 13.0679 2.75 12C2.75 6.89137 6.89137 2.75 12 2.75C17.1086 2.75 21.25 6.89137 21.25 12C21.25 13.0679 21.069 14.0935 20.7361 15.0479" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M6.5 20L12 10L17.5 20L12 17.7778L6.5 20Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/></CentralIconBase>;
};

export default IconInitiatives;
